const GAP_PX = 8;

/** Bottom edge of the sticky top bar shown at this width (desktop header or mobile bar). */
function stickyHeaderBottom(): number {
  let bottom = 0;
  document.querySelectorAll("[data-sticky-header]").forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.height > 0) bottom = Math.max(bottom, rect.bottom);
  });
  return bottom;
}

/** Nearest ancestor that scrolls vertically (e.g. a modal body), or null for the window. */
function scrollParent(el: Element): HTMLElement | null {
  for (
    let node = el.parentElement;
    node && node !== document.body;
    node = node.parentElement
  ) {
    const { overflowY } = window.getComputedStyle(node);
    if (
      (overflowY === "auto" || overflowY === "scroll") &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }
  }
  return null;
}

/**
 * After a page change, bring the top of a paginated list back into view, so the
 * new page is read from its first row instead of wherever the shorter or longer
 * list leaves the viewport. Does nothing when the top is already visible.
 */
export function scrollToListTop(list: Element | null | undefined): void {
  if (!list) return;
  const container = scrollParent(list);
  const visibleTop = container
    ? container.getBoundingClientRect().top
    : stickyHeaderBottom();
  const offset = list.getBoundingClientRect().top - visibleTop - GAP_PX;
  if (offset >= 0) return;
  if (container) container.scrollBy({ top: offset });
  else window.scrollBy({ top: offset });
}
